/* @ngInject */
export default function SearchExecutorService($location, $translate, QueryApiService, SleuthService, SpinnerLoadingService, APP_ERROR_CODES) {
    function searchKeyWordsBySleuth(searchWords, navigateCallBack) {
        SpinnerLoadingService.showLoading();

        // const targetMfgs = checkManufacturer(targetmfg);
        const queryParameter = {
            input: searchWords,
            targetMfgs: []
        };

        QueryApiService.executeQueryByRaw(queryParameter, function (results) {
            if ((results.message === null && (results.detectedDefinitions === null || results.detectedDefinitions.length === 0) ) || // error occurred on sleuth
                (results.message.type === 'ERROR')) { // sleuth return no results

                var message;
                if (results.message === null) {
                    message = $translate.instant('message__errorText').valueOf();
                } else {
                    message = results.message.text;
                }
                SleuthService.storeErrorDetectedParameterValues(results.detectedParameterValues);

                SleuthService.sendMessageToUser(
                    {
                        message: {
                            text: message,
                            type: 'error'
                        }
                    },
                    '/'
                );

                $location.search('search', searchWords);
                $location.search('error', APP_ERROR_CODES.NO_RESULTS);

                // [CE-296] Commented out codes that redirect the user back to the home page
                // everytime that there is an error. Now the error message will show up on
                // the same page the user is currently on. Prevented redirection to the main
                // page because it's init() include a clearSearchBar().
                // To re-enable the redirection code, comment out the code above and uncomment
                // the code below.

                // SleuthService.sendMessageToUser(
                //     {
                //         message: {
                //             text: message,
                //             type: 'error'
                //         }
                //     },
                //     '/'
                // );

                $location.path('/');

            } else {
                SleuthService.storeSleuthData(results);
                SleuthService.buildQueryData(results, navigateCallBack);
            }
            SpinnerLoadingService.hideLoading();
        }, function (error) {
            console.log('There was an error in the Search controller.', error);
            SpinnerLoadingService.hideLoading();
        });
    }

    return {
        searchKeyWordsBySleuth: searchKeyWordsBySleuth
    };

    function checkManufacturer(manufacturer) {

        return ['KEMET']

        //TODO currently removed until multibrand is more ready for production
        /*
        let targetMfgs;
        switch (manufacturer) {
            case 'ALL':
                targetMfgs = ['KEMET', 'YAGEO'];
                break;
            case 'KEMET':
                targetMfgs = ['KEMET'];
                break;
            case 'YAGEO':
                targetMfgs = ['YAGEO'];
                break;
            default:
                break;
        }
        return targetMfgs;
        */
    }

}
